import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react';

import { Stripes2View } from './careers-benefits-stripes2.view';

export const Stripes2 = () => {
  const { stripes } = useStaticQuery(graphql`
    query {
      stripes: file(relativePath: { eq: "pages/careers/benefits/careers-benefits-stripes2.svg" }) {
        publicURL
      }
    }
  `);

  return <Stripes2View imageSrc={stripes.publicURL} />;
};
